/**
 * LanguageToggle — small EN/FR pill in the header that flips the
 * current i18next language. Choice is persisted in localStorage by
 * the i18n bootstrap so subsequent visits pick up the same language.
 *
 * Shown in both desktop nav and inside the mobile menu.
 */
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

export function LanguageToggle({ variant = "compact" }) {
  const { i18n, t } = useTranslation();
  const isFr = (i18n.resolvedLanguage || i18n.language || "en").startsWith("fr");

  const toggle = () => {
    i18n.changeLanguage(isFr ? "en" : "fr");
  };

  if (variant === "mobile") {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-label={t("language.ariaLabel")}
        data-testid="language-toggle-mobile"
        className="w-full flex items-center justify-between rounded-2xl border border-brand-navy/10 bg-white/60 hover:bg-white transition px-4 py-3 text-brand-navy"
      >
        <span className="inline-flex items-center gap-2 text-sm font-semibold">
          <Languages className="h-4 w-4 text-brand-teal" />
          {isFr ? "Français" : "English"}
        </span>
        <span className="text-xs font-semibold text-brand-teal">
          → {isFr ? "English" : "Français"}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t("language.ariaLabel")}
      data-testid="language-toggle"
      className="inline-flex items-center rounded-full border border-brand-navy/15 bg-white/70 hover:bg-white transition h-9 p-1 gap-0.5"
    >
      <span
        className={`px-2.5 h-7 rounded-full text-xs font-bold tracking-wide flex items-center ${
          !isFr ? "bg-brand-navy text-white" : "text-brand-navy/60"
        }`}
      >
        EN
      </span>
      <span
        className={`px-2.5 h-7 rounded-full text-xs font-bold tracking-wide flex items-center ${
          isFr ? "bg-brand-navy text-white" : "text-brand-navy/60"
        }`}
      >
        FR
      </span>
    </button>
  );
}

export default LanguageToggle;
